<template>
  <div class="bg-platinumMild font-light w-full h-28 mb-6 flex justify-center items-center text-sm text-cosmosFire rounded-lg">
    <h2>{{text}}</h2>
  </div>
</template>

<script>
export default {
    name:"EmptyState",
    props: {
        text: {
            type: String,
            require:true
        },
    },
}
</script>
